/** The references object of all modules needed for components initialization */
var references = {
    'login': require('_core_ext/login'),
    'reviews-carousel' : require('_core_ext/reviews-carousel'),
};

module.exports = {
    'references' : references
};
